import { getDetailExperienceRevive } from 'services/apis/detail-experience-inspire-api';
import { GET_DETAIL_EXPERIENCE_REVIVE } from 'constants/detail-experience-inspire';

export const getDetailExperienceReviveAction = (id) => ({
  type: GET_DETAIL_EXPERIENCE_REVIVE,
  payload: getDetailExperienceRevive(id),
});
